import { useSyncExternalStore } from 'react';

const STORAGE_KEY = 'po.inboxRead.v1';
const listeners = new Set<() => void>();
let cache = '{}';

function snapshot(): string {
  try { cache = localStorage.getItem(STORAGE_KEY) ?? '{}'; } catch { /* без сховища — останній відомий стан */ }
  return cache;
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  window.addEventListener('storage', listener);
  return () => { listeners.delete(listener); window.removeEventListener('storage', listener); };
}

/** Поточні локальні позначки користувача: ключ елемента → прочитано. */
export function readOverrides(userId: string): Record<string, boolean> {
  try { return (JSON.parse(snapshot()) as Record<string, Record<string, boolean>>)[userId] ?? {}; } catch { return {}; }
}

/**
 * Локальна позначка «прочитано / непрочитано» для елементів, стан яких сервер поки не зберігає (похідні нагадування й коментарі,
 * «Позначити непрочитаним»): localStorage окремо для кожного користувача, синхронізується між вкладками; без сховища — лише в пам'яті.
 * read = null — прибрати позначки (сервер уже має той самий стан).
 */
export function setReadOverrides(userId: string, keys: readonly string[], read: boolean | null): void {
  let all: Record<string, Record<string, boolean>> = {};
  try { all = JSON.parse(snapshot()) as Record<string, Record<string, boolean>>; } catch { all = {}; }
  const mine = { ...all[userId] };
  keys.forEach((k) => { if (read === null) delete mine[k]; else mine[k] = read; });
  const next = JSON.stringify({ ...all, [userId]: mine });
  cache = next;
  try { localStorage.setItem(STORAGE_KEY, next); } catch { /* приватний режим — лише в пам'яті цієї сторінки */ }
  listeners.forEach((l) => l());
}

/** Підписка на локальні позначки (перерендер після «Позначити прочитаним» в іншому місці оболонки). */
export function useReadOverridesVersion(): string {
  return useSyncExternalStore(subscribe, snapshot, () => '{}');
}
